import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load all page components
const Home = lazy(() => import('./pages/home'));
const Advisers = lazy(() => import('./pages/advisers'));
const Adviser = lazy(() => import('./pages/adviser'));
const Clients = lazy(() => import('./pages/clients'));

/**
 * Application routes component
 * Minimal admin portal with just home page
 */
export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/advisers" element={<Advisers />} />
      <Route path="/advisers/:adviserUuid" element={<Adviser />} />
      <Route path="/clients" element={<Clients />} />
    </Routes>
  );
};
